import { LoadingButton } from "@mui/lab";
import { Button, TableCell, TableRow } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  activateCustomerThunk,
  deleteCustomerThunk,
} from "store/reducers/user_profiles/customerSlice";

const CustomerProfileItem = ({ customer, update }) => {
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.customers);

  const deactivate = (item) => {
    dispatch(deleteCustomerThunk(item));
  };

  const activate = (item) => {
    dispatch(activateCustomerThunk(item));
  };

  return (
    <>
      <TableRow
        key={customer.id}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
        }}
      >
        <TableCell align="left" component="th" scope="row">
          {customer.id}
        </TableCell>
        <TableCell align="left" component="th" scope="row">
          {customer.first_name}
        </TableCell>
        <TableCell align="left" component="th" scope="row">
          {customer.last_name ?? "-"}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {customer.employee_id ?? "-"}
        </TableCell>

        <TableCell align="center" component="th" scope="row">
          {customer.secondary_phone ?? "-"}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {customer.balance ?? "-"}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {customer.location ?? "-"}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {customer.biometric ? "Available" : "Not available"}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {customer.rfid ?? "-"}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {customer.aadhaar ?? "-"}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          <Button variant="outlined" onClick={() => update(customer)}>
            Update
          </Button>
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          <LoadingButton
            variant="outlined"
            sx={{ width: "10ch" }}
            color="error"
            onClick={() => {
              deactivate(customer);
            }}
            loading={status?.loading === "delete" && status?.id === customer.id}
          >
            Delete
          </LoadingButton>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CustomerProfileItem;
